<template>
  <div class="confirmation-delete-visit" >
    <Dialog width="580px" :canCloseWithEsc="true" :showCloseIcon="true" >
      <template slot="title">
        <div class="title">
          {{ modalConfirmationDeleteVisit.title }}
        </div>
      </template>

      <template slot="body">
        <div class="description" v-html="modalConfirmationDeleteVisit.data"></div>
      </template>

      <template slot="actions">
        <div class="d-flex justify-end w-100" style="column-gap: 20px; padding: 12px 20px 28px">
          <Button
            dark
            color="#F16063"
            @click="openConfirm"
          >
            <span>Delete</span>
          </Button>
          <Button
            dark
            outlined
            color="grey"
            @click="close"
          >
            <span style="color: #1A202C">Cancel</span>
          </Button>

        </div>
      </template>
    </Dialog>
    <confirm v-if="dialogs.confirm.isOpen" @close="close"/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Dialog from '@/components/layouts/dialog'
import Button from '@/components/elements/Button'
import confirm from '@/components/layouts/dialogs/confirm-dialog'

export default {
  name: 'modal-confirmation-delete-visit',
  components: { Dialog, Button, confirm },
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    close () {
      this.TOGGLE_DIALOG({ name: 'modalConfirmationDeleteVisit', isOpen: false, root: true })
    },
    openConfirm () {
      this.TOGGLE_DIALOG({
        name: 'confirm',
        whose: 'confirmationDeleteVisit',
        visitId: this.modalConfirmationDeleteVisit.visitId,
        isOpen: true,
        action: 'visits/deleteVisit',
        afterAction: { name: '/patients' },
        title: 'Confirm Evaluation Delete',
        description: 'This operation cannot be undone and the Evaluation will be permanently deleted.'
      })

    }
  },
  computed: {
    ...mapState({
      modalConfirmationDeleteVisit: state => state.dialogs.modalConfirmationDeleteVisit
    }),
    dialogs () {
      return this.$store.state.dialogs
    }
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.confirmation-delete-visit {
  ::v-deep .v-btn {
    border-radius: 16px;
    height: 56px;
    font-size: 14px;
    letter-spacing: 0;
    padding: 0 24px;
  }
  ::v-deep .v-dialog__container {
    .v-card {
      &__title {
        padding: 36px 36px 33px !important;
        position: relative;
        .image {
          text-align: center;
          cursor: pointer;
        }
        .title {
          font-family: 'Poppins';
          font-weight: 600;
          font-size: 28px !important;
          color: #27272E;
          letter-spacing: 0 !important;
        }
        .v-icon {
          display: none;
          position: absolute;
          right: 15px;
          top: 25px;
        }
      }
      &__text {
        .description {
          font-family: 'Poppins';
          padding: 0 36px 63px 36px;
          font-weight: 400;
          font-size: 18px;
          line-height: 1.66;
          color: #1A202C;
          letter-spacing: 0;
          p {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
